module.exports = __webpack_public_path__ + "static/media/logoWoocommerce.c2291240.png";